"use client";

import React from 'react'

import L from 'next/link'

import queryString from 'query-string';

import parse from 'url-parse';

interface LinkProps {
  to?: string;
  to_?: string;
  href?: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  openWithNewTab?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export default function Link(props: LinkProps) {

    const { to, to_, href, children, className, style, openWithNewTab, onClick } = props

    const t = removeAbsolutePrefixIfPossible(href || to || to_ || '');

    const newWindowProps = openWithNewTab ? { target: "_blank" } : {};

    if (t && t.startsWith('http')) {
        return (
            <a className={className} onClick={e => {
                if (typeof (window) !== 'undefined') {
                    e.preventDefault();
                    const url = wrapRK(t);
                    if(openWithNewTab) {
                        window.open(url, "_blank");
                    } else {                            
                        window.location.href = url;
                    }
                }
            }} style={style} href={t} {...newWindowProps}>
                {children}
            </a>
        )
    } else {
        return <L className={className} style={style} href={t} onClick={onClick} {...newWindowProps}>{children}</L>
    }

}


// 如果 URL 是绝对路径但在同一个 host，则移除前面的绝对路径和
// https://git.qunfengshe.com/qunfengshe/bwax-app-admin/-/issues/934

// 这个要实现一下，为了 RichText 里面插入的绝对路径
export function removeAbsolutePrefixIfPossible(url: string): string {

    if(url.startsWith("http")){
        const { hostname , pathname, query, hash } = parse(url)
        if(pathname.startsWith("/__")) {
            // 特殊的一系列url，比如 __redirect__，需要调用服务器的逻辑
            return url
        }

        const mobileHosts: string[] = [] // TODO
        if(mobileHosts.indexOf(hostname) !== -1) {
            const path = pathname + query + hash;

            if(path.match(/\/-\/([^\/]+)\//)) {
                // the url is for some tenant but current url is in platform
                return url 
            } else {
                // not for any tenant
                return path
            }

        } else {
            // 不是同一个域
            return url 
        }
    } else {
        // 不是绝对路径
        return url 
    }
}

// wrap rk
// http://git.qunfengshe.com/qunfengshe/bwax-app-admin/issues/548
export function wrapRK(url: string): string {
    if (url && url.startsWith('http') && url.indexOf("m.qunfengshe.com") != -1) {
        if (typeof (sessionStorage) !== 'undefined') {
            const parentKey = sessionStorage.getItem("_rk_");
            if (parentKey) {
                return queryString.stringifyUrl({ url, query: { "rk": parentKey } })
            }
        }
    }
    return url
}
